import styled, { keyframes } from "styled-components";
import { projects } from "./ProjectData";
import { zoomIn } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;

const Grid = styled.div`
  width: 95%;
  margin: 1.5% auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  @media screen and (max-width: 768px) {
    width: 85%;
    margin: 5% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
`;

const Card = styled.div`
  animation: 2s ${zoomAnimation};
  width: 45%;
  background-color: rgba(0, 0, 0, 0.8);
  min-height: 230px;
  padding: 0px 15px;
  margin-bottom: 1%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  justify-content: space-around;
  border: 1px solid #b026ff;

  & > div:nth-child(1) {
    width: 25%;
  }
  & > div:nth-child(1) > img {
    width: 100%;
    border-radius: 50%;
    box-shadow: 0 0 5px 5px #b026ff;
  }
  & > div:nth-child(2) {
    width: 65%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: white;
    font-family: "Comic Neue", cursive;
  }
  & > div:nth-child(2) > h3 {
    background-color: #b026ff;
    padding: 5px 10px;
    margin-bottom: 4%;
    color: black;
    border-radius: 10px;
    box-shadow: 0 0 2.5px 2.5px white;
  }
  & > div:nth-child(2) > p {
    text-align: justify;
    font-weight: bold;
    margin-bottom: 3%;
  }
  & > div:nth-child(2) > h5 {
    background-color: black;
    padding: 5px 10px;
    text-align: center;
    color: white;
    border-radius: 10px;
    box-shadow: 0 0 2.5px 2.5px white;
  }
  & > div:nth-child(2) > div {
    margin-top: 4%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  & > div:nth-child(2) > div > a {
    width: 20%;
    padding: 5px 10px;
    background-color: #b026ff;
    color: black;
    font-family: "Comic Neue", cursive;
    font-size: 15px;
    font-weight: bold;
    border: none;
    border-radius: 10px;
    text-decoration: none;
    text-align: center;
  }
  & > div:nth-child(2) > div > a:hover {
    background-color: black;
    color: #b026ff;
    border-radius: 20px;
    box-shadow: 0 0 1.5px 1.5px white;
    cursor: pointer;
  }
  @media screen and (max-width: 768px) {
    animation: 2s ${zoomAnimation};
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 15px 0px;
    margin-bottom: 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    justify-content: space-around;
    border: 1px solid #b026ff;

    & > div:nth-child(1) {
      width: 35%;
    }
    & > div:nth-child(1) > img {
      width: 100%;
      border-radius: 50%;
      box-shadow: 0 0 2.5px 2.5px #b026ff;
      margin-bottom: 10%;
    }
    & > div:nth-child(2) {
      width: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      color: white;
      font-family: "Comic Neue", cursive;
    }
    & > div:nth-child(2) > h3 {
      background-color: #b026ff;
      padding: 5px 5px;
      margin-bottom: 8%;
      color: black;
      border-radius: 10px;
      box-shadow: 0 0 2.5px 2.5px white;
    }
    & > div:nth-child(2) > p {
      text-align: justify;
      font-weight: bold;
      margin-bottom: 8%;
    }
    & > div:nth-child(2) > h5 {
      background-color: black;
      padding: 5px 10px;
      text-align: center;
      color: white;
      border-radius: 10px;
      box-shadow: 0 0 2.5px 2.5px white;
    }
    & > div:nth-child(2) > div {
      margin-top: 8%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
`;

export function ProjectGrid() {
  return (
    <>
      <Grid>
        {projects.map((el, index) => {
          return (
            <Card key={index}>
              <div>
                <img src={el.image} alt="project_screenshot" />
              </div>
              <div>
                <h3>{el.title}</h3>
                <p>{el.des}</p>
                <h5>{el.tech}</h5>
                <div>
                  <a href={el.code} target="_blank" rel="noreferrer">
                    Code
                  </a>
                  <a href={el.demo} target="_blank" rel="noreferrer">
                    Video
                  </a>
                  <a href={el.dep} target="_blank" rel="noreferrer">
                    Demo
                  </a>
                </div>
              </div>
            </Card>
          );
        })}
      </Grid>
    </>
  );
}
